import StoreSubscriptions from '@/models/loyaltyPanel/subscriptions/StoreSubscriptions';
import { formatBillingPeriodValue } from '@/utils/helpers';
import moment from 'moment';
const getDefaultState = () => ({
  storeSubscriptions: [],
  storeSubscriptionInfo: {},
  updateSubscriptionDialog: false,
  updateAllSubscriptionsDialog: false,
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setStoreSubscriptions(state, payload) {
      state.storeSubscriptions = payload;
    },
    setStoreSubscriptionInfo(state, payload) {
      state.storeSubscriptionInfo = payload;
      state.storeSubscriptionInfo.billings = payload?.billings?.map((b) => {
        b.periodVal = formatBillingPeriodValue(b);
        return b;
      });
    },
    setUpdateSubscriptionDialog(state, payload) {
      state.updateSubscriptionDialog = payload;
    },
    setUpdateAllSubscriptionsDialog(state, payload) {
      state.updateAllSubscriptionsDialog = payload;
    },
  },

  actions: {
    async getStoreSubscriptions({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await StoreSubscriptions.get(body);

        const { store_subscriptions, pagination } = data.data;

        commit('setStoreSubscriptions', store_subscriptions);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async updateSettings({ commit }, payload) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await StoreSubscriptions.updateSettings(payload);

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex?.response?.data?.message || 'error',
          },

          { root: true }
        );
      }
    },

    async updateUnpaidSettings({ commit, state }, payload) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await StoreSubscriptions.updateUnpaidSettings(payload);
        if (!data.error) {
          let subscription = state.storeSubscriptions.find(
            (x) => x.store_subscription_id === payload.id
          );
          if (subscription) {
            Object.assign(subscription.store_subscription_settings, data.data);
          }
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'Settings updated successfully',
            },
            { root: true }
          );
        }
        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex?.response?.data?.message || 'error',
          },

          { root: true }
        );
      }
    },
  },
};
